import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('printsCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/print'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.prints,
    cacheName: 'prints'
  }));
